import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
@Component({
  selector: 'opt-warning-message',
  templateUrl: './warning-message.component.html',
  styleUrls: ['./warning-message.component.scss']
})
export class WarningMessageComponent implements OnInit {

  //   constructor(public dialogRef: MatDialogRef<WarningMessageComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  // ngOnInit() {
  // }
  constructor(
    public dialogRef: MatDialogRef<WarningMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

      ngOnInit() {}

      close() {
      }

}
